import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class TranslateApiService {
  constructor(private http: HttpClient) {}

  traslateEnToEs(msg, lang) {
    return this.http.get(environment.yandexApi + msg + '&lang=' + lang);
  }
}
